export default __webpack_public_path__ + "static/media/solidario2.cac17a22.jpeg";